/* eslint-disable linebreak-style */
const isUnresolvedPlaceholder = (value) => typeof value === 'string' && /^\$\{.*\}$/.test(value);

export default function safeGetEnv(key) {
  let value;

  // Try runtime env (window.env) set by prerender process
  if (typeof window !== 'undefined' && window.env && Object.prototype.hasOwnProperty.call(window.env, key)) {
    value = window.env[key];
  } else if (typeof process !== 'undefined' && process.env && Object.prototype.hasOwnProperty.call(process.env, key)) {
    // Fallback to process.env during build (when REACT_SNAP is true)
    value = process.env[key];
  }

  // env-config.js still has the literal "${VAR}" template (envsubst runs only at container
  // startup, not at build/pre-render time) — never bake that into a static href.
  if (!value || isUnresolvedPlaceholder(value)) {
    return '#';
  }

  return value;
}
